// Runtime environment bootstrap.
// Reads environment-specific values from window.__ENV__ (set by public/config.js)
// and exposes them as process.env.REACT_APP_* for backward compatibility with existing code.
//
// This enables a single built artifact to run in multiple environments by injecting
// per-environment config at serve time, rather than baking it into the bundle at build time.

declare global {
  interface Window {
    __ENV__?: Record<string, string | undefined>;
  }
}

export const ENV = window.__ENV__ || {};

// Copies each non-empty window.__ENV__ key to process.env. Modules that read
// process.env at load time (Sentry, Pusher, LogRocket) need this copy first.
if (typeof window !== "undefined" && window.__ENV__) {
  Object.entries(window.__ENV__).forEach(([key, value]) => {
    if (value !== undefined && value !== "") {
      (process.env as Record<string, string>)[key] = value;
    }
  });
}

export default ENV;
